/** Max length enforced by buyer-journal PUT /api/user-prompt-settings. */
export const USER_PROMPT_MAX_LENGTH = 2000;
